import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui";
import React, { useEffect, useState } from "react";
import MuiBox from "../MuiBox";

const CustomSelect = ({
  label,
  val,
  onChange,
  error,
  errorMsg,
  options,
  placeholder,
  className,
  variant,
}) => {
  const [selectedVal, setSelectedVal] = useState();

  useEffect(() => {
    setSelectedVal(val);
  }, [val]);

  const isLg = variant === "lg";
  const triggerSizeClass = isLg ? "h-10 text-sm" : "h-8 text-[0.8125rem]";
  const triggerSize = isLg ? "default" : "sm";

  return (
    <MuiBox>
      {label && <Label className="flex w-full max-w-48">{label}</Label>}
      <Select
        value={selectedVal}
        indicatorPosition="right"
        indicatorVisibility={null}
        indicator={<></>}
        onValueChange={(value) => {
          setSelectedVal(value);
          onChange(value);
        }}
      >
        <SelectTrigger
          size={triggerSize}
          className={`w-full ${triggerSizeClass}
          px-3 py-2
          rounded-md // <--- ADDED BORDER RADIUS HERE
          [&>span]:data-[placeholder]:text-muted-foreground/80
          ${error ? "border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/30" : ""}
          ${className ?? ""}`}
        >
          <SelectValue placeholder={selectedVal ? selectedVal : placeholder} />
        </SelectTrigger>
        <SelectContent
          position="popper"
          side="bottom"
          className={"z-[9999] min-w-[200px]"}
        >
          {options?.map((item) => (
            <SelectItem key={item?.value} value={item?.value}>
              {item?.label}
            </SelectItem>
          ))}
        </SelectContent>
        {error ? (
          <div className="text-[0.8125rem] text-red-500 ">{errorMsg}</div>
        ) : null}
      </Select>
    </MuiBox>
  );
};

export default CustomSelect;